import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button } from 'reactstrap';
import {
  TRANSACTION_TYPE_BUTTONS_OPTIONS,
  TRANSACTION_TYPE_BUTTON_IDS,
  TRANSACTION_TYPE_PANEL_IDS,
} from 'site-modules/shared/constants/appraisal/appraisal';

import './transaction-type-select-buttons.scss';

export function TransactionTypeSelectButton({ value = '', label = '', onSelect, isSelected = false, id, controls }) {
  const onClick = useCallback(() => onSelect({ value }), [onSelect, value]);

  return (
    <Button
      role="tab"
      id={id}
      aria-controls={controls}
      aria-selected={isSelected}
      className={classnames(
        'transaction-type-select-button size-16 px-1_5 py-0_5',
        isSelected ? 'selected fw-bold' : 'btn-bg-white'
      )}
      onClick={onClick}
      color="none"
    >
      {label}
    </Button>
  );
}

TransactionTypeSelectButton.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  isSelected: PropTypes.bool,
  id: PropTypes.string.isRequired,
  controls: PropTypes.string.isRequired,
};

export function TransactionTypeSelectButtons({ onChange, selected, className = '' }) {
  return (
    <div className={classnames('transaction-type-select-buttons', className)}>
      <div
        role="tablist"
        aria-label="Transaction type options"
        className="d-flex justify-content-center align-items-center"
      >
        {TRANSACTION_TYPE_BUTTONS_OPTIONS.map((option, index) => (
          <TransactionTypeSelectButton
            onSelect={onChange}
            key={option.value}
            value={option.value}
            label={option.label}
            isSelected={option.value === selected}
            id={TRANSACTION_TYPE_BUTTON_IDS[index]}
            controls={TRANSACTION_TYPE_PANEL_IDS[index]}
          />
        ))}
      </div>
    </div>
  );
}

TransactionTypeSelectButtons.propTypes = {
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.string.isRequired,
  className: PropTypes.string,
};
